import { Select } from "antd";
import React, { useEffect, useState } from "react";
import {

  PlusCircleOutlined,
} from "@ant-design/icons";
import { changeCategoryInfo } from "../../../service/shopApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Expertgoods from "./Expertgoods";
import EditGoods from "./addNewAndEdit/EditGoods";
import AddNewGood from "./addNewAndEdit/AddNewGood";

function ExpertProducts({ shopData, setCollapseColor, dataObject }) {
  const [color, setColor] = useState("color5");
  const [editGoods, setEditGoods] = useState(false);
  const [addGoods, setAddGoods] = useState(false);
  const [index, setIndex] = useState();
  const queryClient = useQueryClient();

  const changeThemeMutation = useMutation(changeCategoryInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("expertShop");
    },
  });

  useEffect(() => {
    if (shopData?.themeId === 1) {
      setColor("color1");
      setCollapseColor("color1");
    }
    if (shopData?.themeId === 2) {
      setColor("color2");
      setCollapseColor("color2");
    }
    if (shopData?.themeId === 3) {
      setColor("color3");
      setCollapseColor("color3");
    }
    if (shopData?.themeId === 4) {
      setColor("color4");
      setCollapseColor("color4");
    }
    if (shopData?.themeId === 5) {
      setColor("color5");
      setCollapseColor("color5");
    }
    if (shopData?.themeId === 6) {
      setColor("color6");
      setCollapseColor("color6");
    }
  }, [shopData?.themeId, setCollapseColor]);

  return (
    <div
      className={`h-full ${color} flex flex-row max-lg:flex-col gap-3 p-3 m-[-16px] `}
    >
      <div className="flex flex-col max-lg:flex-row gap-3 max-lg:gap-1 w-[20%] max-lg:w-full max-lg:justify-between ">
        <section className="bg-white rounded-lg p-3 max-lg:gap-2 flex flex-col gap-5 text-right">
          <div className="flex flex-col gap-3  max-lg:gap-2 max-lg:w-[40vw] ">
            <label className="max-lg:text-[13px]">عنوان دسته بندی:</label>
            <Select
              showArrow={false}
              disabled
              value={shopData?.title}
              placeholder="انتخاب کنید"
              className="w-full  max-lg:!text-[10px] text-center "
            />
          </div>
          <div className="items-start text-right flex flex-col gap-5  max-lg:gap-2 ">
            <label className="max-lg:text-[13px]">تصویر دسته بندی:</label>
            <div className="w-[11rem] h-[7rem] max-lg:w-[100px] max-lg:h-[100px] overflow-clip rounded-lg shadow-2xl max-lg:mx-auto ">
              <img
                className="w-full h-full  "
                src={
                  process.env.REACT_APP_ARVAN_S3_BASE_URL + dataObject?.cover
                }
                alt="coverImage"
              />
            </div>
          </div>
        </section>
        <section className="bg-white p-3 max-lg:px-2 flex flex-col gap-6 rounded-lg  h-full max-h-40 max-lg:h-full max-lg:w-[36vw] max-lg:text-right">
          <label className="text-right max-lg:whitespace-nowrap max-lg:text-[13px] ">
            رنگ زمینه دسته بندی:
          </label>

          <div className="flex flex-col max-lg:flex-row gap-4 max-lg:h-full max-lg:justify-around max-lg:py-[5px]">
            <section className="flex flex-row max-lg:flex-col justify-between max-lg:justify-evenly max-lg:gap-6">
              <div
                onClick={() => {
                  setColor("color1");
                  setCollapseColor("color1");
                  changeThemeMutation.mutate({
                    body: { themeId: 1 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color1"
                    ? "w-8 h-8 rounded-full color1 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color1 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => {
                  setColor("color2");
                  setCollapseColor("color2");
                  changeThemeMutation.mutate({
                    body: { themeId: 2 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color2"
                    ? "w-8 h-8 rounded-full color2 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color2 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => {
                  setColor("color3");
                  setCollapseColor("color3");
                  changeThemeMutation.mutate({
                    body: { themeId: 3 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color3"
                    ? "w-8 h-8 rounded-full color3 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color3 cursor-pointer hover:brightness-125"
                }
              />
            </section>
            <section className="flex flex-row max-lg:flex-col justify-between">
              <div
                onClick={() => {
                  setColor("color4");
                  setCollapseColor("color4");
                  changeThemeMutation.mutate({
                    body: { themeId: 4 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color4"
                    ? "w-8 h-8 rounded-full color4 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color4 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => {
                  setColor("color5");
                  setCollapseColor("color5");
                  changeThemeMutation.mutate({
                    body: { themeId: 5 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color5"
                    ? "w-8 h-8 rounded-full color5 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color5 cursor-pointer hover:brightness-125"
                }
              />
              <div
                onClick={() => {
                  setColor("color6");
                  setCollapseColor("color6");
                  changeThemeMutation.mutate({
                    body: { themeId: 6 },
                    categoryId: shopData?.id,
                  });
                }}
                className={
                  color === "color6"
                    ? "w-8 h-8 rounded-full color6 cursor-pointer ring-4 ring-blue-400 "
                    : "w-8 h-8 rounded-full color6 cursor-pointer hover:brightness-90"
                }
              />
            </section>
          </div>
        </section>
      </div>
      <section className="w-[70%] max-lg:w-full">
        {addGoods && !editGoods && (
          <AddNewGood shopData={shopData} setAddGoods={setAddGoods} />
        )}
        {editGoods && !addGoods && (
          <EditGoods
            shopData={shopData?.goods[index]}
            setEditGoods={setEditGoods}
          />
        )}
        {!editGoods && !addGoods && (
          <Expertgoods
            shopData={shopData}
            setEditGoods={setEditGoods}
            setIndex={setIndex}
          />
        )}
      </section>
      {!addGoods && !editGoods && (
        <section className="  flex flex-col rotate-[270deg] max-lg:rotate-0 w-[50px] justify-center items-center text-center mx-auto my-auto whitespace-nowrap ">
          <PlusCircleOutlined
            onClick={() => setAddGoods(true)}
            className="text-white rounded-full text-4xl cursor-pointer"
          />
          <p className="text-white text-lg cursor-default">افزودن محصول جدید</p>
        </section>
      )}
    </div>
  );
}

export default ExpertProducts;
